import $axios from '@/api/apiPublic';

const getFeatures = async category => {
  const response = await $axios.get(`vps/features?category=${category}`);
  return response;
};

export default {
  getFeatures,
};
